import UAParser from 'ua-parser-js';

type DeviceType = 'console' | 'mobile' | 'tablet' | 'smarttv' | 'wearable' | 'embedded' | 'unknown';

type Engine =
    | 'Amaya'
    | 'Blink'
    | 'EdgeHTML'
    | 'Flow'
    | 'Gecko'
    | 'Goanna'
    | 'iCab'
    | 'KHTML'
    | 'LibWeb'
    | 'Links'
    | 'Lynx'
    | 'NetFront'
    | 'NetSurf'
    | 'Presto'
    | 'Tasman'
    | 'Trident'
    | 'w3m'
    | 'WebKit'
    | 'Unknown';

type OS = 'iOS' | 'Android' | 'Unknown';

export const getDeviceType = (userAgent?: string | null): DeviceType => {
    if (!userAgent) return 'unknown';

    try {
        return new UAParser(userAgent).getDevice().type as DeviceType;
    } catch {
        return 'unknown';
    }
};

export const getEngine = (userAgent?: string | null): Engine => {
    if (!userAgent) return 'Unknown';

    try {
        return new UAParser(userAgent).getEngine().name as Engine;
    } catch {
        return 'Unknown';
    }
};

export const getOS = (userAgent?: string | null): OS => {
    if (!userAgent) return 'Unknown';

    try {
        return new UAParser(userAgent ?? window.navigator.userAgent).getOS().name as OS;
    } catch {
        return 'Unknown';
    }
};
